export default __webpack_public_path__ + "static/mehrstufig-live-international-40e853ff6267ec6e2381768c1d0dad75.jpg";